export default "__VITE_ASSET__DnZP27K4__"